// extracted by mini-css-extract-plugin
module.exports = {"sectionManage":"SectionManage_sectionManage_-ZYiZ"};